import React, { useState } from "react";
import {
  MoveRight,
  Phone,
  Mail,
  MapPin,
  Send,
  MessageCircle,
} from "lucide-react";

const Features = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
  };

  return (
    <section
      className="relative py-10 bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 overflow-hidden"
      id="contact"
      dir="rtl"
    >
      {/* Decorative elements */}
      <div className="absolute top-10 right-10 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-80 h-80 bg-purple-500/5 rounded-full blur-3xl"></div>

      <div className="container max-w-6xl px-4 mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4">
            ارتباط با{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              ما
            </span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            برای ارتباط با ما و پیشنهادات و انتقادات لطفا فرم زیر را پر کنید و
            ارسال کنید.
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 lg:p-12 border border-gray-100 dark:border-gray-700">
          {/* Contact Form */}
          <div className="lg:pl-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Name Field */}
                <div className="relative">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="نام شما"
                    className="w-full px-5 py-4 border border-gray-200 dark:border-gray-600 rounded-xl text-right placeholder-gray-400 dark:placeholder-gray-500 bg-white dark:bg-gray-700 text-gray-800 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    required
                  />
                </div>

                {/* Email Field */}
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="ایمیل"
                    className="w-full px-5 py-4 border border-gray-200 dark:border-gray-600 rounded-xl text-right placeholder-gray-400 dark:placeholder-gray-500 bg-white dark:bg-gray-700 text-gray-800 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    required
                  />
                </div>

                {/* Phone Field */}
                <div className="relative">
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="تلفن"
                    className="w-full px-5 py-4 border border-gray-200 dark:border-gray-600 rounded-xl text-right placeholder-gray-400 dark:placeholder-gray-500 bg-white dark:bg-gray-700 text-gray-800 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    required
                  />
                </div>

                {/* Company Field */}
                <div className="relative">
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="شرکت"
                    className="w-full px-5 py-4 border border-gray-200 dark:border-gray-600 rounded-xl text-right placeholder-gray-400 dark:placeholder-gray-500 bg-white dark:bg-gray-700 text-gray-800 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                </div>
              </div>

              {/* Message Field */}
              <div className="relative">
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="پیام خود را بنویسید..."
                  rows={5}
                  className="w-full px-5 py-4 border border-gray-200 dark:border-gray-600 rounded-xl text-right placeholder-gray-400 dark:placeholder-gray-500 bg-white dark:bg-gray-700 text-gray-800 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none"
                  required
                ></textarea>
                <MessageCircle
                  className="absolute left-4 top-4 text-gray-400"
                  size={20}
                />
              </div>

              <button
                type="submit"
                className="group w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium py-4 px-6 rounded-xl shadow-lg hover:shadow-blue-500/25 transition-all duration-300 flex items-center justify-center"
              >
                <Send
                  size={18}
                  className="ml-2 transform group-hover:-translate-x-1 transition-transform"
                />
                <span>ارسال پیام</span>
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="lg:pr-6 lg:border-r lg:border-gray-200 dark:lg:border-gray-700 lg:pl-6">
            <h3 className="text-2xl text-right font-bold text-gray-800 dark:text-white mb-6 flex items-center justify-between   ">
              اطلاعات تماس
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 p-2 rounded-lg ml-3">
                <Phone size={20} className="text-white" />
              </span>
            </h3>

            <div className="space-y-6">
              <div className="flex text-right items-start justify-between">
                <div className="text-right">
                  <h4 className="font-semibold text-gray-800 dark:text-white mb-1">
                    دفتر مرکزی
                  </h4>
                  <p className="text-gray-600 dark:text-gray-300">
                    خرم آباد، کیلومتر ۵ جاده تهران، پردیس دانشگاهی کمالوند، پارک
                    علم و فناوري لرستان، طبقه هم کف، شركت هاویرتک، کد پستی:
                    ۶۸۱۵۱۴۴۳۱۲
                  </p>
                </div>
                <div className="bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg ml-2 flex-shrink-0">
                  <MapPin
                    size={18}
                    className="text-blue-600 text-left dark:text-blue-400"
                  />
                </div>
              </div>

              <div className="flex text-right items-center justify-between">
                <div className="">
                  <h4 className="font-semibold text-gray-800 dark:text-white mb-1">
                    تلفن
                  </h4>
                  <p className="text-gray-600 dark:text-gray-300">
                    09374683780
                  </p>
                </div>
                <div className="bg-green-100 dark:bg-green-900/30 p-3 rounded-lg ml-4 flex-shrink-0">
                  <Phone
                    size={20}
                    className="text-green-600 dark:text-green-400"
                  />
                </div>
              </div>

              <div className="flex text-right items-center justify-between">
                <div className="text-right">
                  <h4 className="font-semibold text-gray-800 dark:text-white mb-1">
                    ایمیل
                  </h4>
                  <a
                    href="mailto:info@havirtech.ir"
                    className="text-blue-600 dark:text-blue-400 hover:underline"
                  >
                    info@havirtech.ir
                  </a>
                </div>
                <div className="bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg ml-4 flex-shrink-0">
                  <Mail
                    size={20}
                    className="text-purple-600 dark:text-purple-400"
                  />
                </div>
              </div>
            </div>

            {/* Additional decorative element */}
            <div className="mt-8 p-6 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 rounded-xl border border-blue-100 dark:border-blue-800/30">
              <p className="text-sm text-gray-600 dark:text-gray-300 text-center">
                ما در کمتر از ۲۴ ساعت به تمامی پیام‌های شما پاسخ خواهیم داد.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
